export default "<div id=\"search-loading-indicator\">\n\t<div class=\"search-lines-container\">\n\t\t<div class=\"search-lines\"></div>\n\t</div>\n</div>"